


























































import gql from 'graphql-tag';
import { mapActions } from 'vuex';
import { get } from 'lodash';
import ZenButton from '@reciprocity/button';
import LoadingSpinner from '@reciprocity/loading-spinner';
import { VISUALIZATIONS, DimensionOptions } from '@/constants/DashboardConstants';
import { userCanSeeDrilldown } from '@/utils/DashboardUtils';
import Visualization from './visualizations/Visualization.vue';
import {
  SERIES_BLOCK_QUERY,
  seriesVariables,
  seriesUpdate,
  seriesFormattedAndFiltered,
} from '../../components/cards/dashboards/components/SeriesUtils';
import DashboardBlockEmptyState from '../../components/cards/dashboards/components/DashboardBlockEmptyState.vue';

export default {
  name: 'DashboardBlock',
  components: {
    ZenButton,
    LoadingSpinner,
    Visualization,
    DashboardBlockEmptyState,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    dashboardId: {
      type: String,
      required: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    viewableButDisabled: {
      type: Boolean,
      default: false,
    },
    userRole: {
      type: String,
      default: null,
    },
    highlighted: {
      type: Boolean,
      default: false,
    },
  },
  apollo: {
    block: {
      query: gql`
        query DashboardBlock($id: ID!) {
          block: node(id: $id) {
            nodeId: id
            ... on DashboardBlock {
              id
              title {
                value
              }
              settings {
                value
              }
              textContent {
                value
              }
            }
          }
        }
      `,
      variables() {
        const { id } = this;

        return {
          id,
        };
      },
      update(result) {
        const { block } = result;
        const id = get(block, 'id');
        const nodeId = get(block, 'nodeId');
        const title = get(block, 'title.value');
        const textContent = get(block, 'textContent.value');
        // TODO: Backend returns a string. Remove JSON parse
        const settings = JSON.parse(get(block, 'settings.value'));

        return {
          id,
          nodeId,
          title,
          settings,
          textContent,
        };
      },
      error() {
        this.showAlert({
          type: 'error',
          message: 'Failed to load Dashboard Block.',
        });
      },
    },
    userRole: {
      query: gql`
        query GetUserRole {
          currentUser {
            userRole {
              value
            }
          }
        }
      `,
      update(result) {
        return get(result, 'currentUser.userRole.value');
      },
    },
    series: {
      query: SERIES_BLOCK_QUERY,
      variables() {
        return seriesVariables(this.block.settings);
      },
      skip() {
        return !this.block || this.isRichText;
      },
      update(result) {
        return seriesUpdate(result, this.block.settings);
      },
      error() {
        this.showAlert({
          type: 'error',
          message: 'Failed to load Dashboard Block data.',
        });
      },
    },
  },
  data() {
    return {
      block: null,
      series: [],
    };
  },
  computed: {
    isRichText() {
      return this.block.settings.visualization === VISUALIZATIONS.RICH_TEXT;
    },
    seriesFormattedAndFiltered() {
      return seriesFormattedAndFiltered(this.block.settings, this.series);
    },
  },
  watch: {
    block: {
      handler(block, previousBlock) {
        const dimensionPath = 'settings.dimension';
        const dimension = get(block, dimensionPath);
        const previousDimension = get(previousBlock, dimensionPath);

        // block's dimension has been updated
        if (dimension !== previousDimension) {
          this.filterByDimension = [];
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      showModal: 'modals/show',
      showAlert: 'alerts/show',
    }),
    async onEditBlock() {
      try {
        const updatedBlock = await this.showModal({
          type: 'DashboardBlockCard',
          data: {
            dashboardId: this.dashboardId,
            cardTitle: this.viewableButDisabled ? 'View Block' : 'Edit Block',
            block: this.block,
            disabled: this.viewableButDisabled,
          },
        });

        // TODO: Refactor this to be a little nicer
        if (updatedBlock.removed) {
          this.$emit('removed', this.block.nodeId);
        } else {
          this.block.title = updatedBlock.title.value;
          this.block.settings = JSON.parse(updatedBlock.settings.value);
          this.$emit('updated');
        }
      } catch (e) {
        // User closed modal
      }
    },
    async onVisualizationClick({ name, data }) {
      if (!userCanSeeDrilldown(this.userRole)) {
        return;
      }
      const {
        block: {
          title,
          settings: { metric, dimension, customAttrId, customAttrType, mappedObject, mappedObjectAttr, filters },
        },
      } = this;

      const disabled = get(DimensionOptions, `${dimension}.drilldownDisabled`);

      if (disabled) {
        this.showAlert({
          type: 'warning',
          message: 'Sorry. Drilldown for this particular dimension is not yet implemented',
        });
        return;
      }

      try {
        await this.showModal({
          type: 'DashboardDrilldownCard',
          data: {
            dimensionItem: name,
            dimensionItemId: data.labelId,
            title,
            metric,
            dimension: dimension ? dimension : null,
            mappedObject: mappedObject ? mappedObject : null,
            mappedObjectAttr: mappedObjectAttr ? mappedObjectAttr : null,
            customAttrId: customAttrId ? customAttrId : null,
            customAttrType: customAttrType ? customAttrType : null,
            filters,
          },
        });
      } catch (e) {
        //
      }
    },
  },
};
